import { Skeleton } from "@shared/src/components/ui/skeleton";

export default function MerchantFoundSkeleton() {
  return (
    <div className="flex flex-col w-full max-w-lg mx-auto">
      <div className="text-center space-y-2 mb-6">
        <Skeleton className="h-6 w-48 mx-auto" />
        <Skeleton className="h-4 w-64 mx-auto" />
      </div>

      {/* Trade Details Card Skeleton */}
      <div className="border-2 border-border-secondary rounded-3xl p-4 sm:p-6 w-full mb-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 gap-4 sm:gap-0">
          <Skeleton className="h-5 w-24" />
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <div className="flex items-center gap-1 w-full sm:w-auto">
              <Skeleton className="h-6 w-20" />
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-6 w-20" />
            </div>
          </div>
        </div>

        <div className="space-y-4">
          {/* Fiat Amount Skeleton */}
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-24" />
          </div>

          {/* Price Skeleton */}
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-24" />
          </div>

          {/* Total Quantity Skeleton */}
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-24" />
          </div>

          {/* Payment Method Skeleton */}
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-24" />
          </div>
        </div>
      </div>

      {/* Merchant Details Card Skeleton */}
      <div className="flex-1 bg-surfaces-bg-secondary-darker p-3 md:p-6 rounded-3xl flex flex-col mb-6">
        {/* Merchant Header Skeleton */}
        <div className="flex items-center mb-4">
          <Skeleton className="h-8 w-8 rounded-xl" />
          <div className="ml-4">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-4 w-24 mt-1" />
            <div className="flex items-center gap-2 mt-1">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-4 w-4" />
            </div>
          </div>
        </div>

        {/* Quick Info Skeleton */}
        <div className="w-full grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
          <div>
            <Skeleton className="h-5 w-16" />
            <Skeleton className="h-4 w-24 mt-1" />
          </div>
          <div>
            <Skeleton className="h-5 w-16" />
            <Skeleton className="h-4 w-24 mt-1" />
          </div>
          <div className="col-span-2 md:col-span-1">
            <Skeleton className="h-5 w-16" />
            <Skeleton className="h-4 w-24 mt-1" />
          </div>
        </div>

        {/* Advertiser Terms Skeleton */}
        <div className="flex-1 p-4 rounded-2xl border border-border-tertiary bg-black">
          <Skeleton className="h-4 w-24 mb-2" />
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
          </div>
        </div>
      </div>

      {/* Cancel Button Skeleton */}
      <Skeleton className="h-10 w-full rounded-full" />
    </div>
  );
}
